import Bulb from '../../assets/reactions/1f4a1.svg'
import Clap from '../../assets/reactions/1f44f.svg'
import Heart from '../../assets/reactions/2764.svg'
import Laugh from '../../assets/reactions/1f601.svg'
import Thumb from '../../assets/reactions/1f44d.svg'

export type Reaction = {
  colon: string
  src: string
  alt: string
}

export default function useReactions(): Reaction[] {
  const clap: Reaction = {
    colon: ':reaction::clap:',
    src: Clap,
    alt: 'Clap reaction',
  }

  const bulb: Reaction = {
    colon: ':reaction::bulb:',
    src: Bulb,
    alt: 'Bulb reaction',
  }

  const thumb: Reaction = {
    colon: ':reaction::thumb:',
    src: Thumb,
    alt: 'Thumb reaction',
  }

  const laugh: Reaction = {
    colon: ':reaction::laugh:',
    src: Laugh,
    alt: 'Laugh reaction',
  }

  const heart: Reaction = {
    colon: ':reaction::heart:',
    src: Heart,
    alt: 'Heart reaction',
  }

  return [clap, thumb, heart, laugh, bulb]
}
